$(function () {
    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang;
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];
    const getRecaptchaToken = require('./recaptchaHelper');

    $.ajaxSetup({
        headers: { "X-TimeZoneName": timeZoneName, "X-Language": language },
        contentType: "application/json; charset=utf-8",
        dataType: "json"
    });

    const Uris = {
        jsonBookingsAdd: envSettings.server + "/json/competitions/addanswer",
        nextPageUri: "/fi/kiitos-toimiala-jarjestot-ja-kolmas-sektori/"
    };

    $("#thirdsectorForm").on("submit", function (event) {
        event.preventDefault();
        if ($('#thirdsectorForm')[0].checkValidity()) {
            $("#thirdsectorFormSendBtn").prop("disabled", true);
            $("#thirdsectorFormSendBtn").css("background-color", "#6c757d");
            let email = $("#thirdsectorFormEmail").val();
            let firstName = $("#thirdsectorFormFirstName").val();
            let lastName = $("#thirdsectorFormLastName").val();
            let phone = $("#thirdsectorFormPhoneNumber").val();
            let message = $("#thirdsectorFormMessage").val();
            let organization = $("#thirdsectorFormOrganization").val();
            let code = "";
            /*  if ($('#languageServicesNewsLetterCheckbox').is(':checked')) {
                 code = "newsletter";
             } */
            let data = {
                email: email,
                firstName: firstName,
                lastName: lastName,
                additionalInformation: message,
                phoneNumber: phone,
                organizationName: organization,
                competitionName: "Jarjestot-ja-kolmas-sektori",
                uri: "/fi/jarjestot-ja-kolmas-sektori",
                languageCode: language,
                code: code,
            };


            getRecaptchaToken().then(function(token) {
                data.recaptchaToken = token;
                $.ajax({
                    url: Uris.jsonBookingsAdd,
                    method: "POST",
                    data: JSON.stringify(data)
                })
                .done(function () {
                    window.location.href = Uris.nextPageUri;
                })
                .fail(function (err) {
                    console.error(err);
                    $("#thirdsectorFormSendBtn").prop("disabled", false);
                    $("#thirdsectorFormSendBtn").css("background-color", "#28a745");
                });
            });
        }
    });

    // Function to toggle button state based on form validity and checkbox
    function toggleSendButtonState() {
        const formValid = $('#thirdsectorForm')[0].checkValidity();

        if (formValid) {
            // Enable button and change color
            $("#thirdsectorFormSendBtn").prop("disabled", false);
            $("#thirdsectorFormSendBtn").css("background-color", "#28a745"); // Change to your desired color (e.g., green)
        } else {
            // Disable button and reset color
            $("#thirdsectorFormSendBtn").prop("disabled", true);
            $("#thirdsectorFormSendBtn").css({
                "background-color": "#6c757d", // Change to your disabled color (e.g., grey)
                "border": "none",
                "outline": "none"
            });
        }
    }

    // Trigger the button state change on input and checkbox changes
    $('#thirdsectorForm input').on('input change', toggleSendButtonState);



    // Initial button state check
    toggleSendButtonState();
});